import { Component, Vue, Prop } from "vue-property-decorator";
import { getLocalStorage } from "@/utils/storage";
import vueQr from "vue-qr";
import * as JsBarcode from "jsbarcode";
import dayjs from "dayjs";
import "./viewtab.less";

@Component({
  vueQr,
})
export default class ViewTab extends Vue {
  @Prop({ default: false }) readonly showLeft: boolean;
  @Prop({ default: () => ({ default: true }) }) readonly authorization: any;

  auth: any = {};

  mounted() {
    const data = getLocalStorage("deviceExport");
    if (this.authorization.default) {
      this.auth = data;
    } else {
      this.auth = this.authorization;
    }
    JsBarcode.default("#jsbarcode", this.auth.sn?this.auth.sn: this.auth.gatewayCode);
  }

  created(): void {
    setTimeout(() => {
      if (this.$route.path.indexOf('/printDevice') > -1) {
        console.log('执行打印！！！')
        window.print()
      }
    }, 1000)
  }

  render() {
    return (
      <div style="display:flex;align-items:flex-start;" class="devices-export">
        {this.showLeft ? (
          <div style="border:1px solid #ccc;width:200px;height:430px;padding:10px;">
            {this.auth.aesFile}
          </div>
        ) : null}

        <div style="color:#000;position:relative">
          <div style="padding-left: 30px;">
            <div class="tabview-up">
              <div>
                <div class="title">MasterLink</div>
                <div style="margin-top: 182px;">
                  <svg
                    width="40"
                    height="30"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      id="svg_1"
                      fill-rule="evenodd"
                      fill="black"
                      d="m16.814574,0.598398c-4.532007,0.837543 -8.583305,2.948313 -11.082943,5.774769c-6.907995,7.810947 -2.885817,18.442077 8.313159,21.973019c3.871649,1.220586 8.144933,1.321387 12.20116,0.287842c3.908161,-0.995912 6.780314,-2.647703 9.258447,-5.324077c2.342164,-2.529878 3.47875,-5.298541 3.483678,-8.48676c0.0056,-3.523774 -1.147786,-6.091284 -4.02061,-8.951116c-2.650391,-2.638295 -4.933866,-3.907713 -8.914604,-4.955818c-2.257939,-0.594501 -6.880219,-0.753542 -9.238287,-0.317859m8.229158,1.590414c4.977322,1.123818 9.188782,4.110883 11.008798,7.808035c0.930728,1.890576 1.22641,3.441117 1.085961,5.693681c-0.102145,1.63835 -0.242146,2.135634 -1.071849,3.810273c-1.786863,3.605983 -5.362382,6.365238 -9.971221,7.695138c-1.519181,0.438372 -2.296468,0.512964 -5.360814,0.514532c-4.23162,0.002016 -5.611248,-0.287842 -8.848075,-1.858992c-1.777455,-0.862855 -2.443189,-1.348044 -4.040994,-2.946073c-2.149746,-2.150194 -2.955481,-3.562526 -3.497566,-6.131604c-1.713839,-8.121189 6.968027,-15.612933 17.394644,-15.010592c1.047209,0.060481 2.53279,0.252002 3.301116,0.425604m-8.477352,5.11262c-2.511061,1.020777 -4.278885,2.576694 -5.203116,4.579271c-0.751078,1.62715 -0.688134,4.435462 0.137089,6.119284c0.340707,0.694854 1.077897,1.686286 1.638574,2.203059c1.160554,1.069833 3.472478,2.230611 4.796329,2.408021l0.895336,0.120065l0,-1.037353c0,-0.570757 0.04592,-1.037577 0.102145,-1.037577c0.056,0 0.46682,0.247522 0.912808,0.550149c0.98628,0.669542 3.056282,1.465869 3.809601,1.465869c0.50938,0 0.551493,-0.082209 0.551493,-1.073641l0,-1.073417l-0.952008,-0.255586c-2.225683,-0.597413 -4.036738,-3.170971 -4.02621,-5.721009c0.003136,-0.768103 0.122529,-1.69883 0.265218,-2.068434c0.448228,-1.160106 1.792687,-2.337012 3.106011,-2.718935l1.195274,-0.347427l-0.155681,-1.15473c-0.085793,-0.635269 -0.199362,-1.228426 -0.25245,-1.318251c-0.053088,-0.089601 -0.599205,0.027776 -1.213418,0.261186c-2.428629,0.922888 -4.557543,2.742455 -5.377614,4.596519c-1.055273,2.38562 -0.689478,5.339086 0.925128,7.47248c0.92692,1.224842 0.880328,1.352076 -0.313827,0.853223c-2.517557,-1.051913 -4.131939,-4.244612 -3.493086,-6.907995c0.386179,-1.609006 1.659854,-2.956601 3.2767,-3.466206l1.221482,-0.385059l-0.149633,-1.130314c-0.082209,-0.621829 -0.214818,-1.201098 -0.294787,-1.287115c-0.079745,-0.086241 -0.710534,0.073249 -1.401356,0.353923m11.348385,0.030912c-2.778072,1.129194 -4.801257,3.093242 -5.506191,5.345134c-0.43098,1.37694 -0.178978,4.064067 0.506916,5.407182c1.058185,2.071346 3.340989,3.775328 5.996531,4.476006l1.118666,0.295011l0,-1.15921l0,-1.15921l-1.076329,-0.382147c-3.427005,-1.217226 -4.95649,-5.966739 -2.83676,-8.808875c0.528421,-0.708294 1.992721,-1.553005 3.074874,-1.773647c0.588005,-0.119841 0.610853,-0.172033 0.471076,-1.073193c-0.279106,-1.799631 -0.246178,-1.777679 -1.748783,-1.16705"
                    />
                  </svg>
                </div>
                <div>
                  <svg
                    width="46"
                    height="35"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      id="svg_1"
                      fill-rule="evenodd"
                      fill="black"
                      d="m15.071003,5.207974c-2.200831,0.402511 -3.89032,1.125052 -5.606551,2.397532c-2.581204,1.913813 -4.322316,4.649987 -5.049755,7.935805c-0.249892,1.129068 -0.307002,3.481539 -0.112162,4.624616c0.761724,4.46847 3.391222,8.007707 7.328561,9.864214c1.965437,0.926686 3.025641,1.177264 5.295631,1.25181l1.640803,0.053877l0,-0.535734c0,-0.294659 0.0288,-1.200284 0.063869,-2.012457l0.063967,-1.476723l-0.774753,0.053093c-1.399727,0.095999 -3.344593,-0.296716 -4.593857,-0.92747c-1.704084,-0.860369 -3.295908,-2.418005 -4.101714,-4.013453c-1.973764,-3.908442 -0.985559,-8.633857 2.369613,-11.330259c0.877021,-0.704909 2.127558,-1.362209 3.201476,-1.682827c0.734296,-0.219231 1.131223,-0.271247 2.375491,-0.31141l1.493865,-0.048196l0,-1.936833c0,-1.675676 -0.020865,-1.944768 -0.15497,-1.996196c-0.276537,-0.106089 -2.715113,-0.041828 -3.439515,0.090612m22.525924,-0.001469c-3.660019,0.572175 -6.868451,2.615195 -8.982295,5.719497c-0.737725,1.083518 -1.075583,1.776182 -1.526877,3.131044c-0.568159,1.705358 -0.719504,2.77232 -0.65397,4.609334c0.058089,1.626795 0.193468,2.408307 0.664844,3.838793c1.468592,4.456421 5.385067,7.844214 10.001062,8.650999c0.820206,0.143313 2.523702,0.24519 3.141134,0.187884l0.661219,-0.06142l-0.000196,-1.969649l-0.000196,-1.969551l-1.297753,-0.011951c-1.400511,-0.012931 -2.328765,-0.189452 -3.500641,-0.665627c-2.273908,-0.923944 -4.311932,-3.091763 -5.090016,-5.41416c-0.164374,-0.490772 -0.298871,-0.942654 -0.298871,-1.004269c0,-0.079934 0.469808,-0.109615 1.640803,-0.103738c0.902491,0.004604 2.59962,0.006367 3.771398,0.004016l2.130595,-0.004212l0,-1.959168l0,-1.959168l-3.773259,0l-3.773259,0l0.064359,-0.269386c0.216782,-0.907095 0.90494,-2.374609 1.462029,-3.118016c1.894319,-2.527424 4.720125,-3.893062 7.737341,-3.739072l1.025624,0.052408l0,-1.987184c0,-1.721619 -0.020669,-1.995021 -0.15497,-2.046547c-0.265467,-0.101877 -2.401058,-0.0432 -3.248104,0.089142"
                    />
                  </svg>
                </div>
              </div>
              <div class="tabview-right">
                <div>
                  <vueQr
                    text={`${this.auth.parseAesAddress}${this.auth.aesFile}`}
                    size={200}
                  ></vueQr>
                </div>
                <div style="margin-left: 10px;margin-top: -15px;position:relative">
                  <div>
                    {"Name"}：{this.auth.name}
                  </div>
                  <div class="tabview-detail">
                    <div class="tabview-detail-left">
                      <div>
                        Date：
                        {dayjs(this.auth.createTime).format("YYYY-MM-DD")}
                      </div>
                      <div>{"Power_Supply"}：DC9-36V</div>
                    </div>
                    <div class="tabview-detail-right">
                      {this.auth.productName}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: center;    width: 238px;">
              <div>
                <div class="text" style="text-align: left;">
                  {"Made_in_China"}
                </div>
                <div>
                  <img class="image" id="jsbarcode" />
                </div>
                <div class="text">SN：{this.auth.sn? this.auth.sn:this.auth.gatewayCode}</div>
                <div class="text">0510-88787830</div>
                <div class="text">www.wimisoft.com</div>
              </div>
              <div class="text">
                {"Copyright"}
                <i nz-icon nzType="copyright" nzTheme="outline"></i>
                {"Wuxi_WeiMing_Intelligent_Technology_Co.,Ltd."}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
